import MapboxDraw from '@mapbox/mapbox-gl-draw';

const {
  cursors,
  geojsonTypes,
  modes,
  meta
} = MapboxDraw.constants;

function patchSimpleSelect(SimpleSelect) {
  const SimpleSelectPatched = {
    ...SimpleSelect
  };
  SimpleSelectPatched.clickOnFeature = function (state, e) {
    if (e.featureTarget.geometry.type !== geojsonTypes.POINT) {
      // switch to direct_select mode for polygon/line features
      this.changeMode(modes.DIRECT_SELECT, {
        featureId: e.featureTarget.properties.id
      });
    } else {
      // call parent
      SimpleSelect.clickOnFeature.call(this, state, e);

      // prevent multi-selection for consistency with direct_select mode
      this.setSelected(e.featureTarget.properties.id);
    }
  };
  return SimpleSelectPatched;
}

function patchDirectSelect(DirectSelect) {
  let preventFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => true;
  let onPreventDragging = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => undefined;
  const DirectSelectPatched = {
    ...DirectSelect
  };
  DirectSelectPatched.clickInactive = function (state, e) {
    if (e.featureTarget.geometry.type !== geojsonTypes.POINT) {
      // switch to direct_select mode for polygon/line features
      this.changeMode(modes.DIRECT_SELECT, {
        featureId: e.featureTarget.properties.id
      });
    } else {
      // switch to simple_select mode for point features
      this.changeMode(modes.SIMPLE_SELECT, {
        featureIds: [e.featureTarget.properties.id]
      });
    }
  };
  DirectSelectPatched.dragFeature = function (state, e, delta) {
    const geojson = state.feature.toGeoJSON();
    if (preventFunction(geojson, e, delta)) {
      onPreventDragging();
      // prevent dragging polygon/line features
      // noop
    } else {
      // call parent
      DirectSelect.dragFeature.call(this, state, e, delta);
    }
  };
  DirectSelectPatched.onMouseMove = function (state, e) {
    // call parent
    const result = DirectSelect.onMouseMove.call(this, state, e);
    const geojson = state.feature.toGeoJSON();
    if (preventFunction(geojson, e)) {
      // show pointer cursor on inactive features, move cursor on active feature vertices
      const isFeature = MapboxDraw.lib.CommonSelectors.isInactiveFeature(e);
      const onVertex = MapboxDraw.lib.CommonSelectors.isOfMetaType(meta.VERTEX)(e);
      const onMidpoint = MapboxDraw.lib.CommonSelectors.isOfMetaType(meta.MIDPOINT)(e);
      if (isFeature || onMidpoint) this.updateUIClasses({
        mouse: cursors.POINTER
      });else if (onVertex) this.updateUIClasses({
        mouse: cursors.MOVE
      });else this.updateUIClasses({
        mouse: cursors.NONE
      });
    }
    return result;
  };
  return DirectSelectPatched;
}

function enable(modes$1) {
  let preventFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => true;
  return {
    ...modes$1,
    [modes.SIMPLE_SELECT]: patchSimpleSelect(modes$1[modes.SIMPLE_SELECT]),
    [modes.DIRECT_SELECT]: patchDirectSelect(modes$1[modes.DIRECT_SELECT], preventFunction)
  };
}

export { enable };
//# sourceMappingURL=mapbox-gl-draw-waypoint.esm.js.map
